import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../store/global-selectors';
import { downloadDocumentRequest } from '../../../../store/ltl/ltl.actions';
import { freightActionButtonMessages } from './messages';

import style from '../../../../components/grid-header/shared-classes.module.less';

export const PrintFreightButton = () => {
  const dispatch = useDispatch();
  const selectedShipmentIds = useSelector(Global.selectLtlGridSelectedShipmentIds) ?? emptyArray;
  const selectedShipments = useSelector((state: unknown) =>
    selectedShipmentIds
      .map((id: string) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId: id }))
      .filter((s: { productTransactionId?: string } | null) => s?.productTransactionId),
  );

  const isDisabled = selectedShipments.length === 0;

  const dispatchForAll = useCallback(
    (documentType: string) => {
      selectedShipments.forEach((shipment: { productTransactionId: string }) => {
        dispatch(downloadDocumentRequest(shipment.productTransactionId, documentType));
      });
    },
    [dispatch, selectedShipments],
  );

  const onPrintBillOfLading = useCallback(() => {
    dispatchForAll('BILL_OF_LADING');
  }, [dispatchForAll]);

  const onPrintPackingList = useCallback(() => {
    dispatchForAll('PACKING_LIST');
  }, [dispatchForAll]);

  const onPrintPalletLabels = useCallback(() => {
    dispatchForAll('PALLET_LABEL');
  }, [dispatchForAll]);

  const onPrintRateQuote = useCallback(() => {
    dispatchForAll('QUOTE');
  }, [dispatchForAll]);

  return (
    <DropdownMenu className={style['action-bar-button']} disabled={isDisabled} menuPosition='bottom-right'>
      <DropdownMenuToggler theme='tertiary'>
        <FormattedMessage {...freightActionButtonMessages.print} />
      </DropdownMenuToggler>
      <DropdownMenuItem onClick={onPrintBillOfLading}>
        <FormattedMessage {...freightActionButtonMessages.billOfLading} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintPackingList}>
        <FormattedMessage {...freightActionButtonMessages.packingList} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintPalletLabels}>
        <FormattedMessage {...freightActionButtonMessages.palletLabels} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintRateQuote}>
        <FormattedMessage {...freightActionButtonMessages.rateQuote} />
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
